import { motion } from 'framer-motion';
import './Pricing.scss';
import { FaCheck } from 'react-icons/fa';

const Pricing = () => {

  return (
    <main className="pricing" id="pricing">
      <section className="cards section">
        <div className="container">
          <div className="pricing-grid">
            {/* 유료 서비스 */}
            <motion.article
              className="card paid-service"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
            >
              {/* <div className="card-badge paid">유료</div> */}
              <div className="card-header">
                <h2 className="card-name">PDF를 HWP로 변환</h2>
              </div>
              <div className="card-price">
                <span className="card-amount">
                  <span className="card-highlight">30원</span>
                </span>
                <span className="card-period">/페이지</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />가입비 0원 · 사용 기간 제한 없음</li>
                <li className="card-feature"><FaCheck className="feature-icon" />빠른 변환 속도 및 고퀄의 결과물</li>
              </ul>
            </motion.article>

            {/* PRO 서비스 */}
            <motion.article
              className="card pro-service"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.15 }}
            >
              {/* <div className="card-badge pro">PRO</div> */}
              <div className="card-header">
                <h2 className="card-name">PDF를 HWP로 변환 PRO</h2>
              </div>
              <div className="card-price">
                <span className="card-amount">
                  <span className="card-highlight">40원</span>
                </span>
                <span className="card-period">/페이지</span>
              </div>
              <ul className="card-features">
                <li className="card-feature"><FaCheck className="feature-icon" />낙서 시험지 고급 분석</li>
                <li className="card-feature"><FaCheck className="feature-icon" />수식 로만체 표현 최적화</li>
                <li className="card-feature"><FaCheck className="feature-icon" />띄어쓰기 자동 교정</li>
                <li className="card-feature"><FaCheck className="feature-icon" />다단 레이아웃 자동 구분</li>
              </ul>
            </motion.article>

            {/* 무료 서비스들 */}
            <motion.article
              className="card free-service"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              {/* <div className="card-badge free">무료</div> */}
              <div className="card-header">
                <h2 className="card-name">수학 문제 풀이 AI</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">0원</span>
                <span className="card-period">/문항</span>
              </div>
            
              <ul className="card-features">
                <li className="card-feature highlight"><FaCheck className="feature-icon" />AI 이용 시 aip 계정 필요</li>
                <li className="card-feature"><FaCheck className="feature-icon" />수학 문제 정답 및 풀이 생성</li>
                <li className="card-feature"><FaCheck className="feature-icon" />HWP로 변환 가능</li>
              </ul>
            </motion.article>

            <motion.article
              className="card free-service"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
            >
              {/* <div className="card-badge free">무료</div> */}
              <div className="card-header">
                <h2 className="card-name">수학 문제 변형 AI</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">0원</span>
                <span className="card-period">/문항</span>
              </div>
              <ul className="card-features">
                <li className="card-feature highlight"><FaCheck className="feature-icon" />AI 이용 시 aip 계정 필요</li>
                <li className="card-feature"><FaCheck className="feature-icon" />수학 쌍둥이 유사 문제로 변형</li>
                <li className="card-feature"><FaCheck className="feature-icon" />HWP로 변환 가능</li>
              </ul>
            </motion.article>

            <motion.article
              className="card free-service"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.4 }}
            >
              {/* <div className="card-badge free">무료</div> */}
              <div className="card-header">
                <h2 className="card-name">수학 도형 그리기 AI</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">0원</span>
                <span className="card-period">/문항</span>
              </div>
              <ul className="card-features">
                <li className="card-feature highlight"><FaCheck className="feature-icon" />AI 이용 시 aip 계정 필요</li>
                <li className="card-feature"><FaCheck className="feature-icon" />수학 도형을 고퀄로 새로 그림</li>
                <li className="card-feature"><FaCheck className="feature-icon" />매쓰테일러 그림판을 이용한 보정</li>
              </ul>
            </motion.article>

            <motion.article
              className="card free-service"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              {/* <div className="card-badge free">무료</div> */}
              <div className="card-header">
                <h2 className="card-name">수학 도형 전용 그림판</h2>
              </div>
              <div className="card-price-free">
                <span className="free-text">0원</span>
                <span className="card-period">/문항</span>
              </div>
              <ul className="card-features">
                <li className="card-feature highlight"><FaCheck className="feature-icon" />AI 이용 시 aip 계정 필요</li>
                <li className="card-feature"><FaCheck className="feature-icon" />쉽고 빠른 수학 도형 그리기</li>
                <li className="card-feature"><FaCheck className="feature-icon" />수학 도형 빠른 복제</li>
              </ul>
            </motion.article>
          </div>
        </div>
      </section>

    </main>
  );
};

export default Pricing;

